// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import './assets/css/screen.css';
import './assets/font/icon.css';
import router from './router'
import * as echarts from 'echarts'
import "echarts-gl"
import md5 from 'js-md5'
import  jquery from 'jquery'
import Api from './bll/axiosapi.js'
import scroll from 'vue-seamless-scroll'
// import config from '../package.json'
import config from'../config'

//导入图片预览viewer组件以及css
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import myStorage from "./bll/utils";
import VueMeta from 'vue-meta'
Vue.use(Viewer)
Vue.use(scroll)
Vue.use(ElementUI)
Vue.use(VueMeta)

Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.$ = jquery
Vue.prototype.$api = Api
Vue.prototype.$versionclient = config.version.client
Vue.prototype.$md5 = md5

router.beforeEach((to,from,next)=>{
  let user=myStorage.getItem('localStorage','userinfo') //localStorage.getItem('userinfo')
  let paths=to.path
  document.title = to.meta.title || process.env.COMPANY_NAME
  if(paths=='/storagevideo'||paths=='/productionalarm'||paths.indexOf('\/user\/')>=0){
    if(user){
      next()
    }else {
      ElementUI.MessageBox.alert('您还未登录或登录已失效，请重新登录！', '系统提示', {
        confirmButtonText: '去登录',
        type: 'warning',
        center: true,
        callback: action => {
          next({path: '/login?login=no'})
        }
      })
    }
  }else {
    next()
  }
})

/**
 * 浏览器开发模式安全提示
 */
try {
  window.console && window.console.log && (
    console.log(
      `%c `+process.env.COMPANY_NAME+` %c v`+config.version.internal,
      'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
      'background:#007aff ;padding: 1px; border-radius: 0 3px 3px 0;  color: #fff; font-weight: bold;'
    ),
    console.log("%c此浏览器功能专供开发者使用。请不要在此粘贴执行任何内容，这可能会导致您的账号受到攻击， 给您带来损失！", "font-size:18px;color:red"),
      console.log("%c:::::::::::::____:::::::____::::::::::::::::::____:::::::::____:::::::::::::::::::::::\n:::::::::::/|    |:::::/|    |:::::::::::::::/\\    \\::::::/\\    \\:::::::::::::::::::::\n::::::::::|:|    |::::|:|    |::::::::::::::/::\\    \\::::/::\\____\\::::::::::::::::::::\n::::::::::|:|    |::::|:|    |::::::::::::::\\:::\\    \\::/:::/    /::::::::::::::::::::\n::::::::::|:|    |::::|:|    |:::::::::::::::\\:::\\    \\/:::/    /:::::::::::::::::::::\n::::::::::|:|    |::::|:|    |::::::::::::::::\\:::\\   /:::/    /::::::::::::::::::::::\n::::::::::|:|    |::::|:|    |:::::::::::::::::\\:::\\ /:::/    /:::::::::::::::::::::::\n::::::::::|:|    |____|_|    |::::::::::::::::::\\:::::::/    /::::::::::::::::::::::::\n::::::::::|:|                |:::::::::::::::::::\\:::::/    /:::::::::::::::::::::::::\n::::::::::|:|     ______     |:::::::::::::::::::/:::::\\    \\:::::::::::::::::::::::::\n::::::::::|:|    |::::|:|    |::::::::::::::::::/:::\\:::\\    \\::::::::::::::::::::::::\n::::::::::|:|    |::::|:|    |:::::::::::::::::/:::/ \\:::\\    \\:::::::::::::::::::::::\n::::::::::|:|    |::::|:|    |::::::::::::::::/:::/   \\:::\\    \\::::::::::::::::::::::\n::::::::::|:|    |::::|:|    |:::::::::::::::/:::/    /\\:::\\    \\:::::::::::::::::::::\n::::::::::|:|    |::::|:|    |::::::::::::::/:::/    /::\\:::\\____\\::::::::::::::::::::\n::::::::::|:|____|::::|:|____|::::::::::::::\\::/    /::::\\::/    /::::::::::::::::::::\n::::::::::|/____/:::::|/____/::::::::::::::::\\/____/::::::\\/____/:::::::::::::fxg:::::\n::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::\n", "color:#0A47B6")
  )
} catch (e) {
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js